import { render, staticRenderFns } from "./right-char-message-textarea.vue?vue&type=template&id=376a7b2d&scoped=true"
import script from "./right-char-message-textarea.vue?vue&type=script&lang=js"
export * from "./right-char-message-textarea.vue?vue&type=script&lang=js"
import style0 from "./right-char-message-textarea.vue?vue&type=style&index=0&id=376a7b2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a7b2d",
  null
  
)

export default component.exports